import React, { forwardRef } from "react";
import { Container } from "./styled/textarea";

const Textarea = forwardRef((props, ref) => {
  return <Container {...props} ref={ref} />;
});

export default Textarea;
